<script context="module">
  import { writable } from 'svelte/store'

  export const sidebarStatus = writable('');

</script>

<script>
import { Inertia } from '@inertiajs/inertia';
import { inertia, page } from '@inertiajs/inertia-svelte'
import Sidebar from '../Partials/Sidebar.svelte';

</script>

<div class="wrapper">

<div id="content" class:collapsed={$sidebarStatus === 'active'}>
<nav class="py-5">
  <div class="px-5">
    <div class="flex justify-between items-center">
      <div>
        <a href="https://www.mur-partners.com">
          <img src="/img/logo-mur-partners.png" alt="Mur&amp;Partners" title="Mur&amp;Partners" width="200" height="23" />
        </a>
      </div>

      <div class="flex gap-4">

        {#if $page.props.back_url == 'list'}
        <a href="/" class="rounded-full bg-transparent text-blue font-semibold hover:bg-blue hover:text-white py-2 px-4 border border-blue whitespace-nowrap flex gap-1">
            Ofertas
        </a>
        {/if}


        <button on:click={() => {sidebarStatus.update(s => s == 'active' ? '' : 'active')}} class="btn-menu rounded-full bg-black hover:bg-black text-white font-semibold hover:text-white">
            <div class="open">
              <i class="fa-solid fa-bars"></i>
            </div>
            <div class="close">
              <i class="fa-light fa-xmark"></i>
            </div>
        </button>

      </div>
    </div>
  </div>
</nav>

<main>
  <slot />
</main>

<footer class="py-16 lg:py-24 bg-blue text-white mt-10">
  <div class="container lg:flex items-end justify-between">
    <div class="mb-12 lg:mb-0">
      <div class="text-6xl text-white mb-6">
        Ready for you.
      </div>
      <div class="mb-12">
        Expertos en la selección de directivos, mandos intermedios y profesionales cualificados.
      </div>
      <div>
        <a href="https://www.mur-partners.com/contacto/" class="rounded-full inline-block bg-white text-black font-semibold py-4 px-6 border border-white">
          Contáctanos
        </a>
      </div>
    </div>
    <div>
      <ul class="list-none">
        <li class="inline-block">
          <a href="https://www.linkedin.com/company/murandpartners" class="p-3" target="_blank"><i class="fa-brands fa-linkedin-in"></i></a>
        </li>
        <li class="inline-block">
          <a href="https://www.instagram.com/murandpartners" class="p-3" target="_blank"><i class="fa-brands fa-instagram"></i></a>
        </li>
        <li class="inline-block">
          <a href="https://www.facebook.com/murandpartners" class="p-3" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
        </li>
        <li class="inline-block">
          <a href="https://twitter.com/MurAndPartners" class="p-3" target="_blank"><i class="fa-brands fa-twitter"></i></a>
        </li>
      </ul>
    </div>
  </div>
</footer>

</div>

<Sidebar />

</div>
